import { useFeatureFlag } from './use-feature-flag';
import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useIsSellerFeatureEnabled } from '../../hooks/use-is-seller-feature-enabled';
import { PackingRecommendations } from '../../constants/features';

export const useEnableProductItemWeightAndDimensions = () => {
  const isFeatureFlagEnabled = useFeatureFlag(FeatureFlagDeclarations.enableProductItemWeightAndDimensions);
  const isPackingRecommendationsEnabled = useIsSellerFeatureEnabled(PackingRecommendations);
  return isFeatureFlagEnabled || isPackingRecommendationsEnabled;
};
